import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { routes } from '../../../../constants/routes';
@Component({
  selector: 'app-workshop-cta',
  standalone: true,
  imports: [],
  templateUrl: './workshop-cta.component.html',
  styleUrl: './workshop-cta.component.scss'
})
export class WorkshopCTAComponent {
  workshopAssets = {
    studentImage: 'images/workshop-student.svg'
  };
  constructor(private router: Router) { }

  navigateToRegister() {
    this.router.navigate([`/${routes.workshop}/${routes.register_university}`])
  }
}
